// Port of api/fuel/app/classes/insights/player/overview.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'

export default Segment.extend({
	name: 'overview',
	priority: -1,
	types: [Constants.TYPE_USER],
	insight: false,
	run: function() {
		var player = this._data.player
		var groupRatio = false
		var groupRatioCount = 0
		var groupRatioWins = 0
		var h2hRatio = false
		var h2hRatioCount = 0
		var h2hRatioWins = 0
		var playKeys = Object.keys(this._data.plays || {})

		for (var i = 0; i < playKeys.length; i++) {
			var play = this._data.plays[playKeys[i]]
			if (play.pl === 2) {
				h2hRatioCount += play.c
				if (player.plays[play.id]) h2hRatioWins += play.c
			} else {
				groupRatioCount += play.c
				if (player.plays[play.id]) groupRatioWins += play.c
			}
		}

		if (groupRatioCount) groupRatio = (100 / groupRatioCount) * groupRatioWins
		if (h2hRatioCount) h2hRatio = (100 / h2hRatioCount) * h2hRatioWins

		return {
			overview: {
				dateFirst: player.dateFirst,
				dateLast: player.dateLast,
				winRatio: player.winRatio,
				perGame: Math.round((player.totalPlays / player.totalGames) * 100) / 100,
				h2hPlays: groupRatioCount,
				groupRatio: groupRatio,
				groups: this._data.groups,
				totalDuration: player.totalDuration,
				h2hRatio: h2hRatio
			}
		}
	}
})
